/**
 * @generated SignedSource<<9f6c22cdc1eb7743c7809d2fa61b8f42>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type homePageElementViewRendererFragment$data = {
  readonly __typename: "HelpLayoutAnnouncementElement";
  readonly " $fragmentSpreads": FragmentRefs<"helpCenterAnnouncementFragment">;
  readonly " $fragmentType": "homePageElementViewRendererFragment";
} | {
  readonly __typename: "HelpLayoutConnectElement";
  readonly __typename: "HelpLayoutConnectElement";
  readonly " $fragmentSpreads": FragmentRefs<"connectElementFragment">;
  readonly " $fragmentType": "homePageElementViewRendererFragment";
} | {
  readonly __typename: "HelpLayoutEditorElement";
  readonly " $fragmentSpreads": FragmentRefs<"editorViewRendererFragment">;
  readonly " $fragmentType": "homePageElementViewRendererFragment";
} | {
  readonly __typename: "HelpLayoutForgeElement";
  readonly __typename: "HelpLayoutForgeElement";
  readonly " $fragmentSpreads": FragmentRefs<"forgeElementFragment">;
  readonly " $fragmentType": "homePageElementViewRendererFragment";
} | {
  readonly __typename: "HelpLayoutHeroElement";
  readonly " $fragmentSpreads": FragmentRefs<"heroElementFragment">;
  readonly " $fragmentType": "homePageElementViewRendererFragment";
} | {
  readonly __typename: "HelpLayoutNoContentElement";
  readonly __typename: "HelpLayoutNoContentElement";
  readonly " $fragmentType": "homePageElementViewRendererFragment";
} | {
  readonly __typename: "HelpLayoutPortalsListElement";
  readonly " $fragmentSpreads": FragmentRefs<"listOfPortalsOnHelpCenter_HelpLayoutListOfHelpCenterPortalsAtomicElement">;
  readonly " $fragmentType": "homePageElementViewRendererFragment";
} | {
  readonly __typename: "HelpLayoutSuggestedRequestFormsListElement";
  readonly " $fragmentSpreads": FragmentRefs<"suggestedRequestForms_HelpLayoutListOfHelpCenterSuggestedRequestFormsAtomicElement">;
  readonly " $fragmentType": "homePageElementViewRendererFragment";
} | {
  readonly __typename: "HelpLayoutTopicsListElement";
  readonly " $fragmentSpreads": FragmentRefs<"listOfTopicsElementFragment">;
  readonly " $fragmentType": "homePageElementViewRendererFragment";
} | {
  readonly __typename: "QueryError";
  readonly extensions: ReadonlyArray<{
    readonly statusCode: number | null | undefined;
  }> | null | undefined;
  readonly identifier: string | null | undefined;
  readonly " $fragmentType": "homePageElementViewRendererFragment";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "homePageElementViewRendererFragment";
};
export type homePageElementViewRendererFragment$key = {
  readonly " $data"?: homePageElementViewRendererFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"homePageElementViewRendererFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "homePageElementViewRendererFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "editorViewRendererFragment"
        }
      ],
      "type": "HelpLayoutEditorElement"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "listOfPortalsOnHelpCenter_HelpLayoutListOfHelpCenterPortalsAtomicElement"
        }
      ],
      "type": "HelpLayoutPortalsListElement"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "suggestedRequestForms_HelpLayoutListOfHelpCenterSuggestedRequestFormsAtomicElement"
        }
      ],
      "type": "HelpLayoutSuggestedRequestFormsListElement"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "helpCenterAnnouncementFragment"
        }
      ],
      "type": "HelpLayoutAnnouncementElement"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "listOfTopicsElementFragment"
        }
      ],
      "type": "HelpLayoutTopicsListElement"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "heroElementFragment"
        }
      ],
      "type": "HelpLayoutHeroElement"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "forgeElementFragment"
        }
      ],
      "type": "HelpLayoutForgeElement"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "connectElementFragment"
        }
      ],
      "type": "HelpLayoutConnectElement"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "identifier"
        },
        {
          "kind": "LinkedField",
          "name": "extensions",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "statusCode"
            }
          ]
        }
      ],
      "type": "QueryError"
    }
  ],
  "type": "HelpLayoutElement",
  "abstractKey": "__isHelpLayoutElement"
};

(node as any).hash = "7d6919efacb003fbbba4ae358d4715a1";

export default node;
